import api from './api';

interface IListStatusesDonationss {
  limit?: number;
  page?: number;
}
interface IEditStatusesDonations {
  id: number | string;
  name: string;
  areaId: number | string;
}
interface ICreateStatusesDonations {
  name: string;
  areaId: number | string;
}

class StatusesDonationsService {
  async listStatusesDonations({
    limit = 200,
    page = 1,
  }: IListStatusesDonationss): Promise<any> {
    const response = await api.get(
      `/financial-management/accounts-receivable/statuses-of-donation`,
      {
        params: {
          limit,
          page,
        },
      },
    );

    return response.data;
  }

  async getStatusesDonationsById(id: number | string): Promise<any> {
    const response = await api.get(`/sectors/${id}`);

    return response.data;
  }

  async deleteStatusesDonationsById(id: number | string): Promise<any> {
    const response = await api.delete(`/sectors/${id}`);

    return response.data;
  }

  async editStatusesDonationsById({
    id,
    name,
    areaId,
  }: IEditStatusesDonations): Promise<any> {
    const response = await api.put(`/sectors/${id}`, {
      name,
      area_id: areaId,
    });

    return response.data;
  }

  async CreateStatusesDonations({
    name,
    areaId,
  }: ICreateStatusesDonations): Promise<any> {
    const response = await api.post(`/sectors`, {
      name,
      area_id: areaId,
    });

    return response.data;
  }
}

export default new StatusesDonationsService();
